import { Link } from 'react-router-dom'
import ScreenHolder from '../../Partials/Layouts/ScreenHolder/ScreenHolder'

function WebsiteContentScreens() {
  return (
    <ScreenHolder>
        <div>
        <div>
          <Link to={'/sliders'} >Sliders</Link>
        </div>
        <div>
          <Link to={'/homePartners'} >Home Partners</Link>
        </div>
        <div>
          <Link to={'/homeCounters'} >Home Counters</Link>
        </div>
        <div>
          <Link to={'/socialLinks'} >Social Links</Link>
        </div>
      </div>
    </ScreenHolder>
  )
}

export default WebsiteContentScreens